import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { checkPath, getPredictSettingsOrganisationsPageUrl, getPredictSettingsRoute } from '@futrli/shared-services';
import { UILoader } from '@futrli/ui-components';

import { StoreState } from '../core/types';

export const PredictSettingsContainer = () => {
  const { pathname } = useLocation();
  const { workspaceId = '' } = useParams();
  const isLoading = useSelector(
    (store: StoreState) => store.loadingRequests?.FETCH_FROM_REMOTE_GET_WORKSPACE_PERMISSIONS === 1
  );

  if (!checkPath(pathname, getPredictSettingsRoute()) && isLoading) {
    return <UILoader isFull={true} />;
  }

  return <Navigate to={getPredictSettingsOrganisationsPageUrl(workspaceId)} replace />;
};
